// extracted by mini-css-extract-plugin
export default {"BillingPeriodSwitch_ButtonGroup":"ar8eoPmB1lADZloJQNBD"};